var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// Copyright Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.
import { CoreUtils, StringUtils } from "@laserfiche/lf-js-utils";
/**
 * Generates a random PKCE code verifier
 * @returns PKCE code verifier
 */
export function generateCodeVerifier() {
  const array = new Uint8Array(25);
  const randomString = generateRandomValuesFromArray(array);
  const code_verifier_raw = Array.from(randomString, StringUtils.base10ToBase16).join('');
  const code_verifier = StringUtils.stringToBase64(code_verifier_raw).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  return code_verifier;
}
/**
 * Generates a PKCE code challenge given the code verifier
 * @param code_verifier - code verifier
 * @returns The PKCE code challenge
 */
export function generateCodeChallengeAsync(code_verifier) {
  return __awaiter(this, void 0, void 0, function* () {
    const base64CodeVerifierHash = (yield createBase64SHA256HashAsync(code_verifier)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return base64CodeVerifierHash;
  });
}
// Generates random array
function generateRandomValuesFromArray(array) {
  if (!CoreUtils.isBrowser()) {
    throw new Error('generateRandomValuesFromArray not implemented in node js.');
  }
  let randomArray = window.crypto.getRandomValues(array);
  return randomArray;
}
function createBase64SHA256HashAsync(message) {
  return __awaiter(this, void 0, void 0, function* () {
    if (!CoreUtils.isBrowser()) {
      throw new Error('createBase64SHA256HashAsync not implemented in node js.');
    }
    const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
    const hashBuffer = yield window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
    const hashEncoded = StringUtils.arrayBufferToBase64(hashBuffer);
    return hashEncoded;
  });
}
